<template>
    <component v-if="totalItemQty > 0 && cartTotal" :is="isBottomBar ? BottomBar : 'div'">
        <Button
            class="h-auto"
            :text="title"
            variant="primary"
            fluid
            :disabled="disable"
            @click="handleNextPage()">
            <span class="d-flex m-16 w-100 align-items-center" style="justify-content: space-between">
                <span class="position-relative w-min-content">
                    <Icon class="text-white" style="width: 1.5rem; height: 1.5rem" size="1-5x" name="far fa-shopping-basket"/>
                    <span class="position-absolute qty-counter flex-center text-midnight-800 tm14 bg-white" v-text="totalItemQty"/>
                </span>
                <span class="tm16 text-white" v-text="title"/>
                <span class="tb16 text-white" v-text="displayWithCurrency(cartTotal.subTotalAmount || 0)"/>
            </span>
        </Button>
    </component>
</template>

<script lang="ts" setup>
import { Icon, Button } from '@helcim/blizzard';
import {computed} from 'vue';
import { useUtilCurrency } from '../../compositions';
import { LINKS } from '../../scripts/constants';
import { useActors } from '../../compositions';
import {useRouter} from 'vue-router';
import {useCartStore} from '../../store/cart';
import BottomBar from './BottomBar.vue';

const router = useRouter();
const cartStore = useCartStore();

const emit = defineEmits<{
    (event: 'click'): void
}>();

withDefaults(defineProps<{
    title?: string,
    categoryId?: string,
    isBottomBar?: boolean,
}>(), {
    title: '',
    categoryId: '',
    isBottomBar: false,
});

const { customer } = useActors();
const { displayWithCurrency } = useUtilCurrency();

const cartTotal = computed(() => {
    return cartStore.cartTotal || null;
});

const totalItemQty = computed(() => {
    return Array.from(cartStore.cartItemQuantities.values()).reduce((a, b) => a + b, 0);
});

const disable = computed(() => {
    return totalItemQty.value === 0;
});

const handleNextPage = (): void => {

    emit('click');

    if(location.pathname.includes(LINKS.QUICK_ORDER)) {
        router.push(LINKS.REVIEW_ORDER + window.location.search);
        return;
    }

    const helcimStoreSubdomains = ['helcim-ca-hardware.helcim.app', 'helcim-us-hardware.helcim.app', 'tastyfood.helcim.app'];
    if(helcimStoreSubdomains.includes(window.location.hostname)) {
        router.push(LINKS.CHECKOUT + window.location.search);
        return;
    }

    if(!customer.value || !customer.value.id) {
        router.push(LINKS.CHECKOUT_LOGIN + window.location.search);
        return;
    }

    router.push(LINKS.CHECKOUT + window.location.search);
    return;
};

</script>
